import { East } from '@mui/icons-material'
import { Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'

import { buildDemoOnboardingPath } from '~/features/onboarding/utils'
import useIsPartner from '~/features/partners/hooks/useIsPartner'
import { EClientPath } from '~/models/api'
import { sessionStore, store } from '~/store'

type TProps = {
  isOnlyCreateLibby?: boolean
}
function CreateOrModifyLibbyButton({ isOnlyCreateLibby = false }: TProps) {
  const navigate = useNavigate()
  const [userId, setUIElements, sideNavOpenSections] = store((state) => [
    state.user.id,
    state.setUIElements,
    state.UIElements.sideNavOpenSections,
  ])
  const agentId = sessionStore((state) => state.agent.id)
  const isPartner = useIsPartner()
  const aiAssistantName = isPartner ? 'AI assistant' : 'Libby'
  const handleRedirectToSettings = () => {
    setUIElements({
      sideNavOpenSections: {
        ...sideNavOpenSections,
        settings: true,
      },
    })
    navigate(EClientPath.settingsCoreBehavior)
  }

  return (
    <Button
      variant="primary"
      endIcon={<East />}
      onClick={() =>
        agentId && userId
          ? handleRedirectToSettings()
          : navigate(buildDemoOnboardingPath(EClientPath.partialBasicInfo))
      }
      sx={{
        width: 'fit-content',
        pointerEvents: 'auto',
      }}
    >
      {isOnlyCreateLibby || !agentId
        ? `Create your AI receptionist`
        : `Modify your ${aiAssistantName}`}
    </Button>
  )
}
export default CreateOrModifyLibbyButton
